const sk = {
  common: {
    wallet: "peňaženka",
    playPage: "hrať",
    minTop: "minimálna suma je $10",
    maxTop: "maximálna suma je $500",
    website: "webstránka",
    signOut: "odhlásiť sa",
    hidden: "skrytý",
    victory: "víťazstvo",
    wentWrong: "niečo sa pokazilo, presmerovanie",
    stakeLabel: "stávka",
    howDoes: "ako to funguje?",
    continue: "Pokračovať",
    continueWithGoogle: "Pokračovať s Google",
    continueWithApple: "Pokračovať s Apple",
    termsOfService: "podmienky služby",
    privacyPolicy: "zásady ochrany osobných údajov",
    termsOfServiceFooter: "podmienky služby",
    privacyPolicyFooter: "zásady ochrany osobných údajov",
    verificationCode: "overovací kód",
    verify: "overiť",
    account: "účet",
    error: "nastala chyba\n",
    checkBackLater: "skontrolujte to neskôr",
    looking: "hľadá sa...",
    yes: "áno",
    no: "nie",
    pleaseSelect: "Prosím, vyberte\n",
    disclaimer: "pokračovaním súhlasíte s našimi\n",
    and: "a",
  },
  endOfGame: {
    wonByCheckmate: "výhra šachmatom",
    lostOnTime: "prehra na čas",
    resigns: "odstúpenie",
    gameDrawnByAgreement: "hra remizovaná dohodou",
    abandonedTheGame: "hra opustená",
    gameAborted: "hra prerušená",
    gameDrawnByStalemate: "hra remizovaná patovou situáciou",
    gameDrawnByFiftyMoveRule: "hra remizovaná pravidlom päťdesiatich ťahov",
    gameDrawnByInsufficientMaterial: "hra remizovaná nedostatočným materiálom",
    gameDrawnByThreefoldRepetition: "hra remizovaná trojitou opakovanosťou",
    draw: "remíza",
    victory: "víťazstvo",
    defeat: "porážka",
    aborted: "prerušené",
    white: "biely",
    black: "čierny",
    inspectBoard: "zobraziť dosku",
    returnToEndOfGameModal: "pokračovať",
  },
  byPhone:{
    continueOnPhone: "pokračovať na\ntelefóne",
    or: "alebo",
    continueOnWeb: "pokračovať na\nwebe",
    disclaimer: "vhodné, ak máte fotografiu svojho ID na disku"
  },
  signUp: {
    email: "e-mail",
    username: "používateľské meno",
    usernameInvalid: "neplatné používateľské meno",
    emailInvalid: "neplatný e-mail",
    login: "prihlásenie",
    continueWithPhone: "pokračovať s telefónnym číslom",
    tickBoxes: "zaškrtnite niekoľko\npolíčok",
    confirm: "Potvrdzujem, že\n",
    resideIn: "Bydlisko\n",
    notPEP: "Nie som politicky exponovaná osoba (PEP), člen rodiny alebo známy spolupracovník PEP\n",
    purpose: "Účel a povaha môjho vzťahu s Gambit je výhradne na používanie služby na zábavu\n",
    soleBenefit: "Službu budem používať výhradne pre môj vlastný prospech a neexistuje žiadny iný skutočný majiteľ\n",
  },
  identity: {
    beingVerified: "identita\nje overovaná",
    verified: "overené\n",
    failed: "overenie\nzlyhalo",
  },
  payment: {
    failed: "platba zlyhala.\nskúste to prosím znova",
    successful: "platba\núspešná!",
    toppedUp: "ste\ndoplnený!",
    topUp: "doplnenie\n",
    payWith: "zaplatiť pomocou...\n",
  },
  gameplay: {
    play: "hrať\n",
    challenge: "vás vyzýva na",
    gameWorth: "hodnota hry\n",
    whatsYourNumber: "aké je vaše\ntelefónne číslo?",
    receiveCode: "čoskoro obdržíte overovací\nkód",
    matchedOpponent: "Budete spárovaný s protihráčom podobného hodnotenia.",
    stake: {
      total: "Celková stávka bude suma vybraná nižšie.",
      contribution: "Prispejete približne polovicou tejto sumy.",
      weakerOpponent: "Ak budete spárovaný so slabším protihráčom, zaplatíte väčšiu časť stávky.",
      strongerOpponent: "Ak budete spárovaný so silnejším protihráčom, zaplatíte menšiu časť stávky.",
    },
    supportInfo: "Pre viac informácií navštívte našu podporu.\n",
    continueBrowser: "pokračovať vo\nwebovom prehliadači",
    continuePhone: "pokračovať na\ntelefóne",
    getStarted: "začnime\n",
    sentText: "poslali sme vám\nSMS",
    enterReceivedCode: "zadajte prijatý\noverovací kód",
    wrongCode: "nesprávny kód, skúste to znova\n",
    secPerMove: "sekúnd na ťah",
    resign: {
      prompt: "ste si istí, že chcete odstúpiť?",
    },
    draw: {
      offer: "prijať ponuku remízy?",
    },
    rating: "hodnotenie\n",
    balance: "zostatok\n",
    rematch: "odveta\n",
    newOpponent: "nový protihráč\n",
    home: "domov\n",
    rematchOffer: "váš protihráč ponúka odvetu. prijať?",
    leaveGame: "Práve hrajete hru. Ste si istí, že chcete odísť?",
    room: "miestnosť:\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Šach plný adrenalínu. Vy a váš protihráč máte každý len 1 minútu na vyhranie hry.",
      },
      blitz: {
        title: "blitz\n",
        description: "Vy a váš protihráč máte každý 3 minúty na vyhranie hry.",
      },
    },
    stakes: {
      unlockNext: "hrať {amount} ďalších hier na odomknutie ďalšej stávky",
      allUnlocked: "všetky stávky odomknuté",
    },
    withdraw: "vybrať\n",
  },
  puzzle: {
    begin: "začať",
    next: "ďalší",
    unavailableInYourRegion: "nedostupné",
    puzzle: "hádanka",
    whiteToPlay: "biely na ťahu",
    blackToPlay: "čierny na ťahu",
    time: "čas",
    solution: "riešenie",
    somethingWentWrong: "niečo sa pokazilo",
    rating: "hodnotenie",
    credits: "kredity",
    puzzleFailed: "prehral",
    puzzleSolved: "výhra",
    correct: "správne riešenie",
    incorrect: "nesprávne riešenie",
    youRanOutOfTime: "vypršal vám čas",
    puzzleDescription: "Máte 10 sekúnd + 2 sekundy/ťah na vyriešenie hádanky.",
    creditsLeft: "zbývajúce kredity",
    refillIn: "doplnenie za",
    lastPuzzle: "toto je vaša posledná hádanka, vráťte sa neskôr pre viac.",
    outOfCredits: "došli vám kredity, vráťte sa neskôr.",
    locationPrompt: "Potrebujeme vašu polohu na pokračovanie. Ak je zablokovaná, prosím, znovu ju povolte:",
    locationInstructions: "Kliknite na ikonu v adresnom riadku, vyberte 'Vždy povoliť' a obnovte stránku",
    creditsError: "Chyba pri načítaní kreditov",
    moves: "Tahy:",
  },
};

export {sk};